import useTranslator from "../../hooks/useTranslator";
import { Form } from "react-bootstrap";
import { useContext, useEffect, useState } from "react";
import { haveValue, toast } from "../../helper/common";
import LandLordContext from "../../context/landlord/LandLordContext";
import AuthContext from "../../context/auth/AuthContext";
import Cancelimg from "../../assets/img/cancel-01.svg";
import FullAddressFormModal from "./FullAddressFormModal";

const AddPropertyManuallyModal = (props) => {
  const {
    step,
    setStep,
    handleShow,
    formData,
    setFormData,
    handleInputChange,
    defaultState,
    handleSubmit,
    handleBackCurrent = null,
    isLandlord = false,
    setIsAddManuallyModal,
    submitLoading,
  } = props;

  const { _t } = useTranslator();
  const landLordContext = useContext(LandLordContext);
  const authContext = useContext(AuthContext);
  const { setLoading } = authContext;
  const { validateCadastre, getBuildingData, properties, getAutoCompleteList } =
    landLordContext;

  const [floorVals, setFloorVals] = useState([]);
  const [fromRef, setFromRef] = useState(false);
  const [autoCompleteList, setAutoCompleteList] = useState([]);
  const [isSelected, setIsSelected] = useState(false);
  const [changeEntered, setChangeEntered] = useState(false);
  const [enteredAddress, setEnteredAddress] = useState("");
  const [doorVals, setDoorVals] = useState([]);
  const [allCadastre, setAllCadastre] = useState([]);

  useEffect(() => {
    if (!changeEntered) {
      const timeoutId = setTimeout(async () => {
        getAutoCompleteList(enteredAddress)
          .then((res) => {
            if (
              haveValue(res?.from_ref) &&
              res?.from_ref == true &&
              res?.results.length > 0
            ) {
              setFromRef(true);
              const val = res?.results[0];
              const temp_data = { ...formData };
              // const temp = {
              temp_data.street_type = val?.tipo_via;
              temp_data.street = val?.via;
              temp_data.street_number = val?.numero_via;
              temp_data.postcode = val?.cp;
              temp_data.staircase = val?.escalera;
              temp_data.floor = val?.piso;
              temp_data.door = val?.puerta;
              temp_data.municipality = val?.municipio;
              temp_data.province = val?.provincia;
              temp_data.code_ine = val?.cod_ine;
              temp_data.code_via = val?.cod_via;
              temp_data.cadastral_reference = val?.referencia_catastral;
              temp_data.area = val?.sup_util;
              // };
              setFormData(temp_data);
              setIsSelected(true);
            } else {
              setFromRef(false);
              if (haveValue(enteredAddress) && res.length == 0) {
                const not_listed = [{ address: "not_found_property" }];
                setAutoCompleteList(not_listed);
              } else {
                setAutoCompleteList(res);
              }
            }
          })
          .catch((err) => {
            console.log(err);
          });
      }, 500);

      return () => clearTimeout(timeoutId);
    }
  }, [enteredAddress]);

  const handleValidateCadastre = async (e) => {
    e.preventDefault();
    if (fromRef == true) {
      handleShow();
    } else {
      if (
        haveValue(formData?.code_ine) &&
        haveValue(formData?.code_via) &&
        haveValue(formData?.street_number)
      ) {
        validateCadastre(
          formData.code_ine,
          formData?.code_via,
          formData?.street_number
        )
          .then((res) => {
            const temp_data = { ...formData };
            temp_data.street_type = res[0].tipo_via;
            temp_data.street = res[0].via;
            temp_data.postcode = res[0].cp;
            temp_data.municipality = res[0].municipio;
            temp_data.province = res[0].provincia;
            if (haveValue(res[0].referencia_catastral)) {
              temp_data.cadastral_reference = res[0].referencia_catastral;
              setFormData(temp_data);
              fetchBuildingData(res[0].referencia_catastral);
            } else {
              setFormData(temp_data);
              handleRedirectManual();
            }
          })
          .catch((err) => {
            console.log(err);
          });
      }
    }
  };

  const fetchBuildingData = async (cadastral_reference) => {
    getBuildingData(
      cadastral_reference,
      formData.code_via,
      formData.street_number
    )
      .then((res) => {
        if (res.length == 1 && !haveValue(res[0].vertical)) {
          setFormData((prev) => ({ ...prev, area: res[0].sup_util }));
          setStep(3);
        } else if (res.length == 0) {
          setStep(3);
        } else {
          const highestFloor = [
            ...new Set(res.map((item) => item.piso)),
          ].sort();
          const highestLetter = {};
          res.forEach((item) => {
            const piso = item.piso;
            const puerta = item.puerta;

            if (!(piso in highestLetter)) {
              highestLetter[piso] = [];
            }
            highestLetter[piso][`${puerta}`] = item;
          });

          setAllCadastre(res);

          setFloorVals(highestFloor);
          setDoorVals(highestLetter);

          handleNext();
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const addVals = () => {
    setLoading(true);
    const check = properties.filter(
      (prop) =>
        prop?.street == `${formData?.street_type}, ${formData?.street}` &&
        prop?.street_number == formData?.street_number &&
        prop?.floor_number == formData?.floor &&
        prop?.flat_number == formData?.door
    );

    if (check.length > 0) {
      toast.error(_t("propertyAlreadyExists"));
    } else {
      const current_selected = doorVals[formData.floor][formData.door];
      const temp_cadastre = allCadastre.filter(
        (item) => item.piso == formData.floor && item.puerta == formData.door
      );

      setFormData((prev) => ({
        ...prev,
        area: current_selected.sup_util,
        staircase: current_selected.escalera,
        cadastral_reference: temp_cadastre[0]?.referencia_catastral,
      }));
      handleShow();
    }
    setLoading(false);
  };

  const handleFloorInput = async (e) => {
    e.preventDefault();
    setFormData((prev) => ({
      ...prev,
      area: doorVals[formData?.floor][formData?.door].sup_util,
    }));
  };

  const handleSelectAddr = async (e) => {
    setEnteredAddress(e.target.textContent);
    const code_ine = e.target.getAttribute("data-cod-ine");
    const code_via = e.target.getAttribute("data-cod-via");
    const entered_address = e.target.getAttribute("data-entered-address");
    setEnteredAddress(entered_address);
    setChangeEntered(true);
    const street_number = haveValue(e.target.getAttribute("data-numero-via"))
      ? e.target.getAttribute("data-numero-via")
      : "";
    setFormData((prevData) => ({
      ...prevData,
      ...defaultState,
      code_ine,
      code_via,
      street_number,
    }));
    setIsSelected(true);
  };

  const handleAddressType = (e) => {
    setChangeEntered(false);
    setEnteredAddress(e.target.value);
    setFormData((prevData) => ({ ...prevData, code_ine: "", code_via: "" }));
  };

  const handleNext = () => {
    setStep((prevStep) => prevStep + 1);
  };

  const handleGoBack = () => {
    setStep((prevStep) => prevStep - 1);
  };

  const handleRedirectManual = () => {
    setStep(3);
  };

  return (
    <>
      <div
        className="right-contentbar mobile-month-payment-box mobile-property-cadastre popup-overlay fixed inset-0 d-flex align-items-center justify-content-center z-50 wrapper-modal"
        onClick={() => setIsAddManuallyModal(false)}
      >
        <div className="w-100" onClick={(e) => e.stopPropagation()}>
          {step === 1 && (
            <div
              className={`steps-wrapper addressModal ${
                isLandlord && "resend-text"
              }`}
            >
              <h4 className="step-name">{_t("whatIsYourAddress")}</h4>

              <div
                className="cursor-pointer"
                onClick={() => setIsAddManuallyModal(false)}
              >
                <img
                  src={Cancelimg}
                  alt="icon"
                  className="canceicon topRightIcon"
                />
              </div>

              <Form className="loginform" onSubmit={handleValidateCadastre}>
                <div className="auth-form add-property-form-box">
                  <div
                    className="row m-0 align-items-end"
                    style={{ width: "90%" }}
                  >
                    <div className="col-md-6">
                      <div className="forminput customInput">
                        <label className="forminput label-text">
                          {_t("streetOrReference")}
                        </label>
                        <input
                          type="text"
                          className="form-control user-auth"
                          name="entedAddress"
                          value={enteredAddress}
                          onChange={handleAddressType}
                          onKeyDown={(e) => setIsSelected(false)}
                          required
                          placeholder={_t("enterStreetOrReference")}
                        />
                        {haveValue(autoCompleteList) &&
                          autoCompleteList.length > 0 &&
                          haveValue(enteredAddress) &&
                          isSelected == false && (
                            <ul className="autocomplete_ul ulList">
                              {autoCompleteList.map((ele, index) =>
                                ele.address == "not_found_property" ? (
                                  <></>
                                ) : (
                                  <li
                                    key={index}
                                    className="autocomplete_li"
                                    data-entered-address={`${ele?.tipo_via} ${ele?.via}, ${ele?.address_2}`}
                                    data-numero-via={
                                      haveValue(ele?.numero_via)
                                        ? ele?.numero_via
                                        : null
                                    }
                                    data-cod-ine={ele.cod_ine}
                                    data-cod-via={ele.cod_via}
                                    onClick={handleSelectAddr}
                                  >
                                    {ele.address}
                                  </li>
                                )
                              )}
                              <li
                                key={"not_listed_house"}
                                className="autocomplete_li"
                                onClick={handleRedirectManual}
                              >
                                {"My House Is Not Listed"}
                              </li>
                            </ul>
                          )}
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div
                        className="forminput customInput"
                        style={{
                          background: !haveValue(formData?.code_ine)
                            ? "#F3F3F3"
                            : "",
                        }}
                      >
                        <label className="forminput label-text">
                          {_t("number")}
                        </label>
                        <input
                          type="text"
                          className="form-control user-auth"
                          name="street_number"
                          value={formData.street_number}
                          onChange={handleInputChange}
                          disabled={!haveValue(formData?.code_ine)}
                          style={{
                            background: !haveValue(formData?.code_ine)
                              ? "#F3F3F3"
                              : "",
                          }}
                          required
                          placeholder={_t("enterNumber")}
                        />
                      </div>
                    </div>
                    <div className="col-md-12">
                      <div className="d-flex align-items-center justify-content-center btngroup gap-3 step-btns-group   mobile-btn-box">
                        {haveValue(handleBackCurrent) && (
                          <button
                            className="btn btnoutline"
                            onClick={handleBackCurrent}
                          >
                            {_t("goBack")}
                          </button>
                        )}
                        <button
                          className="addGuarantorButton"
                          type="submit"
                          disabled={
                            !haveValue(formData?.code_ine) ||
                            !haveValue(formData.street_number)
                          }
                        >
                          {_t("next")}
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </Form>
            </div>
          )}
          {step === 2 && (
            <div
              className={`steps-wrapper addressModal addressModalStepTwo ${
                isLandlord && "resend-text"
              }`}
            >
              <h4 className="step-name">{_t("whatIsYourAddress")}</h4>
              <div
                className="cursor-pointer"
                onClick={() => setIsAddManuallyModal(false)}
              >
                <img
                  src={Cancelimg}
                  alt="icon"
                  className="canceicon topRightIcon"
                />
              </div>
              <Form className="loginform" onSubmit={handleFloorInput}>
                <div className="auth-form authForm">
                  <div className="row w-100 m-0">
                    <div className="col-md-6">
                      <div
                        className="forminput customInput"
                        style={{ background: "#f3f3f3" }}
                      >
                        <label className="forminput label-text">
                          {_t("streetOrReference")}
                        </label>
                        <input
                          type="text"
                          className="form-control user-auth"
                          name="entedAddress"
                          value={enteredAddress}
                          disabled
                          style={{ background: "#f3f3f3" }}
                          placeholder={_t("enterStreetOrReference")}
                        />
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div
                        className="forminput customInput"
                        style={{ background: "#f3f3f3" }}
                      >
                        <label className="forminput label-text">
                          {_t("number")}
                        </label>
                        <input
                          type="text"
                          className="form-control user-auth"
                          name="street_number"
                          value={formData.street_number}
                          style={{ background: "#f3f3f3" }}
                          disabled
                          placeholder={_t("enterNumber")}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="row w-100 m-0">
                    <div className="col-md-6">
                      <div className="forminput customInput">
                        <label className="forminput label-text">
                          {_t("floorNumber")}
                        </label>
                        <select
                          className="form-control"
                          name="floor"
                          id="floor_val"
                          value={formData.floor}
                          onChange={(e) => {
                            handleInputChange(e);
                            setFormData((prev) => ({
                              ...prev,
                              door: "",
                            }));
                          }}
                        >
                          <option value="">{_t("select")}</option>
                          {floorVals.map((floor) => (
                            <option value={floor}>{floor}</option>
                          ))}
                        </select>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="forminput customInput">
                        <label className="forminput label-text">
                          {_t("letter")}
                        </label>
                        <select
                          className="form-control"
                          name="door"
                          id="door_val"
                          value={formData.door}
                          onChange={handleInputChange}
                        >
                          <option value="">{_t("select")}</option>
                          {haveValue(formData?.floor) &&
                            Object.keys(doorVals[formData?.floor]).map(
                              (door) => <option value={door}>{door}</option>
                            )}
                        </select>
                      </div>
                    </div>
                  </div>
                  <div className="forminput row100 text-center">
                    <p className="addManuallyText">
                      {" "}
                      {_t("wantToAddPropertyManually")}
                      <a
                        href={undefined}
                        className="setNoInfoColor"
                        onClick={handleRedirectManual}
                      >
                        {_t("clickHere")}?
                      </a>
                    </p>
                  </div>
                  <div className="btngroup row100 d-flex align-items-center justify-content-center custom-gap-3">
                    <button
                      className="commonButtonPropertyDark commonButtonPropertyLight"
                      type="button"
                      onClick={handleGoBack}
                    >
                      {_t("goBack")}
                    </button>
                    <button
                      className="commonButtonPropertyDark"
                      type="submit"
                      onClick={addVals}
                      disabled={
                        !haveValue(formData?.floor) ||
                        !haveValue(formData?.door)
                      }
                      style={{
                        opacity:
                          !haveValue(formData?.floor) ||
                          !haveValue(formData?.door)
                            ? 0.5
                            : "",
                      }}
                    >
                      {_t("findProperty")}
                    </button>
                  </div>
                </div>
              </Form>
            </div>
          )}
          {step === 3 && (
            <FullAddressFormModal
              isLandlord={isLandlord}
              setIsAddManuallyModal={setIsAddManuallyModal}
              formData={formData}
              handleInputChange={handleInputChange}
              handleSubmit={handleSubmit}
              setStep={setStep}
              setFormData={setFormData}
              submitLoading={submitLoading}
            />
          )}
          {step === 4 && (
            <div
              className={`addressModal steps-wrapper ${
                isLandlord && "resend-text"
              }`}
            >
              <h4>{_t("municipalityAndProvince")}?</h4>
              <div
                className="cursor-pointer"
                onClick={() => setIsAddManuallyModal(false)}
              >
                <img
                  src={Cancelimg}
                  alt="icon"
                  className="canceicon topRightIcon"
                />
              </div>
              <Form className="loginform" onSubmit={handleSubmit}>
                <div className="auth-form authForm">
                  <div className="forminput customInput row50">
                    <label className="forminput label-text">
                      {_t("municipality")}
                    </label>
                    <input
                      type="text"
                      className="form-control user-auth"
                      name="municipality"
                      value={formData?.municipality}
                      onChange={handleInputChange}
                      required
                      placeholder={_t("enterMunicipality")}
                    />
                  </div>
                  <div className="forminput customInput row50">
                    <label className="forminput label-text">
                      {_t("province")}
                    </label>
                    <input
                      type="text"
                      className="form-control user-auth"
                      name="province"
                      value={formData?.province}
                      onChange={handleInputChange}
                      required
                      placeholder={_t("enterProvince")}
                    />
                  </div>
                  <div className="btngroup row100 d-flex align-items-center justify-content-center custom-gap-3">
                    <button
                      className="commonButtonPropertyDark commonButtonPropertyLight"
                      type="button"
                      onClick={handleGoBack}
                    >
                      {_t("goBack")}
                    </button>
                    <button className="commonButtonPropertyDark" type="submit">
                      {_t("submit")}
                    </button>
                  </div>
                </div>
              </Form>
            </div>
          )}
          {step === 5 && (
            <div
              className={` steps-wrapper ${isLandlord && "resend-text"}`}
            ></div>
          )}
        </div>
      </div>
    </>
  );
};

export default AddPropertyManuallyModal;
